import React from 'react';
import styled from '@mui/styles/styled';
import { Typography } from '@mui/material';
import { Diamond } from 'react-bootstrap-icons';
import PropTypes from 'prop-types';

const Container = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1),
	color: theme.palette.danger.main,
}));

function ValidationNotification({ ValidMsg }) {
	return (
		<Container aria-label={ValidMsg}>
			<Diamond style={{ fontWeight: '400', marginTop: '-.33rem' }} />
			<Typography aria-label={ValidMsg}>{ValidMsg}</Typography>
		</Container>
	);
}
ValidationNotification.propTypes = {
	ValidMsg: PropTypes.string,
};
export default ValidationNotification;
